import { createFileRoute } from "@tanstack/react-router";
import { mcpApiRoute } from "@/app-clients/chatgpt-dog-search";

export const Route = createFileRoute("/api/mcp")({
    ...mcpApiRoute,
});
